<div
  class="products-list__filters__section-title font-2 fw-bold uppercase"
  (click)="onToggleDropdown()"
  [ngClass]="{ 'is-active-dropdown': _filter.expanded }"
>
  <div>
    <span class="color--primary-blue">{{ _filter.label | translate }}</span>
    @if (hasSelectedItems) {
      <a
        [attr.id]="'btn-clear-filter-' + _filter.id"
        class="link link-underline small d-block btn-filter-item"
        (click)="onClear()"
        >Clear</a
      >
    }
  </div>
</div>

<div class="products-list__filters__dropdown font-3">
  @if (isSearchAvailable) {
    <input
      [attr.id]="'filter-search-' + _filter.id"
      type="text"
      class="form-control filter-search"
      [(ngModel)]="_filter.searchTerm"
      (keyup)="keyUp.next($event)"
      placeholder="Type to search items"
    />
  }

  <ul class="mt-2 overflow-y-auto overflow-x-hidden" [ngStyle]="styles">
    @for (item of _filter.items; track item) {
      @if (item.isVisible) {
        <li>
          @switch (true) {
            @case (!item.maxPrice && item.children.length > 0) {
              <div>
                <ng-container
                  *ngTemplateOutlet="
                    filterParentLabel;
                    context: { $implicit: item }
                  "
                ></ng-container>
              </div>
            }
            @case (!item.maxPrice && item.children.length <= 0) {
              <div>
                <ng-container
                  *ngTemplateOutlet="filterLabel; context: { $implicit: item }"
                ></ng-container>
              </div>
            }
            @default {
              <div>
                <price-range-slider
                  [rangeValue]="item"
                  (updated)="onPriceUpdate($event)"
                ></price-range-slider>
              </div>
            }
          }
        </li>
      }
    }
  </ul>
  @if (isChanged) {
    <div class="mt-2 text-align-center">
      <button
        [attr.id]="'btn-apply-filter-' + _filter.id"
        class="btn btn-outline-primary"
        (click)="onApplyFilter()"
      >
        Apply Filter
      </button>
    </div>
  }
</div>

<ng-template #filterParentLabel let-item>
  <div>
    <label
      class="products-list__filters__parent custom-control custom-checkbox"
    >
      <input
        [attr.id]="'filter-parent-' + item.id"
        value="{{ item.id }}"
        class="custom-control-input checkbox-dark-gray"
        type="checkbox"
        [(ngModel)]="item.selected"
        (change)="updateParentFilters(item)"
      />
      <span class="custom-control-indicator"></span>
      <span
        class="custom-control-description"
        [innerHTML]="item.label | safeContent"
      ></span>
    </label>
    @for (childItem of item.children; track childItem) {
      @if (childItem.isVisible) {
        <span class="products-list__filters__sub-child filter-brands">
          <ng-container
            *ngTemplateOutlet="filterLabel; context: { $implicit: childItem }"
          ></ng-container>
        </span>
      }
    }
  </div>
</ng-template>

<ng-template #filterLabel let-item>
  <label
    class="custom-control custom-checkbox js-checkbox"
    [attr.data-label]="item.label"
  >
    <input
      [attr.id]="'filter-item-' + item.id"
      value="{{ item.id }}"
      class="custom-control-input checkbox-dark-gray"
      type="checkbox"
      [(ngModel)]="item.selected"
      (change)="updateFilters()"
    />
    <span class="custom-control-indicator"></span>
    <span
      class="custom-control-description"
      [innerHTML]="item.label | safeContent"
    ></span>
  </label>
</ng-template>
